import React from 'react';
import PropTypes from 'prop-types';
import { Icon, grey600 } from '@paypalcorp/pp-react';
import { StyleSheet, css } from '../../utility/paypalAphrodite';

const styles = StyleSheet.create({
  iconLink: {
    cursor: 'pointer',
    color: grey600,
    marginRight: '0.375rem',
  },
});

function SocialShareCopyLink({ handleOpenCopyModal }) {
  return (
    <Icon
      name="share-link"
      onClick={handleOpenCopyModal}
      className={`${css(styles.iconLink)}`}
      data-testid="social-share-copy-link"
      size="lg"
    />
  );
}

SocialShareCopyLink.propTypes = {
  url: PropTypes.string,
  handleOpenCopyModal: PropTypes.func,
};

export default SocialShareCopyLink;
